/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Jan 2022
 * @flow
 */

import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Slot from '../Slot';
import classes from './Cubby.module.css';
import CheckList from '../CheckList';
import SearchInput from '../SearchInput';

const Cubby = props => {
  const [rowArray, setRowArray] = useState([]);
  const [columnArray, setColumnArray] = useState([]);

  const {
    showPopup,
    onSlotActionButtonPress,
    twoDimensionSlot,
    deviceGroup,
    checkList,
    onSlotAssign,
    checksForAssignment,
    onSelectCheckForAssignment,
    ascending,
    checkSortFunc,
    onShowCheckDetails,
    showSearch,
    onToggleSearchInput,
    onSearch,
  } = props;
  const storeInfo = useSelector(state => state.storeInfo);
  const { storeCubby } = storeInfo?.data || {};
  const { rowCount, columnCount } = storeCubby || {};

  useEffect(() => {
    setRowArray(Array.from({ length: rowCount }, (_, rowIndex) => ({ id: `row-${rowIndex}` })));
  }, [rowCount]);

  useEffect(() => {
    setColumnArray(Array.from({ length: columnCount }, (_, colIndex) => ({ id: `col-${colIndex}` })));
  }, [columnCount]);

  return (
    <React.Fragment>
      {showSearch && (
        <SearchInput onSearch={onSearch} onToggleSearchInput={onToggleSearchInput} />
      )}
      <div className={classes.container} style={{ height: showSearch ? '87vh' : '93vh' }}>
        <div className={classes.checksWrapper}>
          <CheckList
            checkList={checkList}
            checksForAssignment={checksForAssignment}
            onSelectCheckForAssignment={onSelectCheckForAssignment}
            ascending={ascending}
            checkSortFunc={checkSortFunc}
            onShowCheckDetails={onShowCheckDetails}
          />
        </div>
        <div className={classes.cubbyWrapper}>
          {rowArray.map((row, rowIndex) =>
            <div key={row.id} className={classes.cubbyRowWrapper}>
              {columnArray.map((col, colIndex) =>
                <Slot
                  key={col.id}
                  slot={twoDimensionSlot[rowIndex][colIndex]}
                  showPopup={showPopup}
                  onSlotActionButtonPress={onSlotActionButtonPress}
                  deviceGroup={deviceGroup}
                  onSlotAssign={onSlotAssign}
                  onShowCheckDetails={onShowCheckDetails}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

export default Cubby;

Cubby.propTypes = {
  showPopup: PropTypes.func,
  onSlotActionButtonPress: PropTypes.func,
  twoDimensionSlot: PropTypes.arrayOf(PropTypes.array),
  deviceGroup: PropTypes.object,
  checkList: PropTypes.array,
  onSlotAssign: PropTypes.func,
  checksForAssignment: PropTypes.instanceOf(Map),
  onSelectCheckForAssignment: PropTypes.func,
  ascending: PropTypes.bool,
  checkSortFunc: PropTypes.func,
  onShowCheckDetails: PropTypes.func,
  showSearch: PropTypes.bool,
  onToggleSearchInput: PropTypes.func,
  onSearch: PropTypes.func,
};

Cubby.defaultProps = {
  showPopup: () => { },
  onSlotActionButtonPress: () => { },
  twoDimensionSlot: [[]],
  deviceGroup: null,
  checkList: [],
  onSlotAssign: () => { },
  checksForAssignment: new Map(),
  onSelectCheckForAssignment: () => { },
  ascending: true,
  checkSortFunc: () => { },
  onShowCheckDetails: () => { },
  showSearch: false,
  onToggleSearchInput: () => { },
  onSearch: () => { },
};
